export interface TickerItem {
  id: number;
  time: string;
  text: string;
}

export interface TimelineItem {
  id: number;
  time: string;
  tag: string;
  hot: boolean;
  title: string;
  excerpt: string;
  image: string;
  comments: number;
  likes: number;
}

export interface ReleaseItem {
  id: number;
  badge: string;
  title: string;
  desc: string;
  image: string;
  source: string;
  updatedAt: string;
  comments: number;
  views: string;
}

export interface ThreadItem {
  id: number;
  avatar: string;
  author: string;
  role: string;
  topic: string;
  content: string;
  time: string;
  likes: number;
  replies: number;
  repliesPreview: string;
}

export interface PhotoItem {
  id: number;
  title: string;
  image: string;
  tag: string;
  likes: number;
  tall: boolean;
}

export interface RankItem {
  id: number;
  title: string;
  heat: string;
  trend: string;
  up: boolean;
}

export const tickerItems: TickerItem[] = [
  { id: 1, time: '刚刚', text: '全网首发线索已同步，正在核验来源' },
  { id: 2, time: '2分钟前', text: '今日热门话题热度突破 86 万' },
  { id: 3, time: '5分钟前', text: '实时更新：三条新料进入首发队列' },
  { id: 4, time: '8分钟前', text: '讨论区新增 412 条实时评论' },
  { id: 5, time: '12分钟前', text: '最新整理：今日必看内容合集已上线' },
  { id: 6, time: '16分钟前', text: '抢先看：多个关键词登上升温榜' },
];

export const timelineItems: TimelineItem[] = [
  {
    id: 1,
    time: '12:48',
    tag: '刚刚',
    hot: true,
    title: '首发线索：新一轮行业变动正在同步核实',
    excerpt:
      '免费看料今日实时跟进，多位信源交叉印证，细节仍在补充。评论区已经有人贴出现场画面，热度持续上升中。',
    image: 'https://readdy.ai/api/search-image?query=city%20street%20scene%20at%20dusk%20with%20warm%20orange%20light%20and%20motion%20blur%20crowd%2C%20editorial%20documentary%20photography%2C%20soft%20grain%2C%20no%20text&width=480&height=360&seq=freekanliao-tl-01&orientation=landscape',
    comments: 286,
    likes: 1420,
  },
  {
    id: 2,
    time: '12:31',
    tag: '实时',
    hot: true,
    title: '今日实时更新：相关话题冲上讨论榜前三',
    excerpt:
      '从上午开始热度一路上扬，最新一条跟帖不到三分钟就收到上百条回复，大家都在蹲后续。',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20smartphone%20screen%20glow%20in%20dark%20warm%20room%2C%20hands%20scrolling%2C%20cinematic%20moody%20lighting%2C%20orange%20accent%2C%20no%20text&width=480&height=360&seq=freekanliao-tl-02&orientation=landscape',
    comments: 194,
    likes: 980,
  },
  {
    id: 3,
    time: '12:09',
    tag: '最新',
    hot: false,
    title: '最新整理：今早到中午的重点内容一页看完',
    excerpt:
      '把散落的消息按时间线串好，谁先发的、谁补充的、哪条被删了，一目了然，适合快速补课。',
    image: 'https://readdy.ai/api/search-image?query=stack%20of%20open%20notebooks%20and%20printed%20pages%20on%20wooden%20desk%20with%20warm%20lamp%20light%2C%20top%20down%2C%20minimal%20editorial%2C%20no%20text&width=480&height=360&seq=freekanliao-tl-03&orientation=landscape',
    comments: 132,
    likes: 764,
  },
  {
    id: 4,
    time: '11:52',
    tag: '爆料',
    hot: false,
    title: '网友投稿：一段现场内容引发大量二次讨论',
    excerpt:
      '投稿人只留了几句话，评论区自己就补全了背景。有人说反转，有人说还要再看看，暂时都还没定论。',
    image: 'https://readdy.ai/api/search-image?query=anonymous%20silhouette%20figure%20backlit%20by%20warm%20amber%20light%20in%20empty%20room%2C%20mysterious%20documentary%20tone%2C%20no%20text&width=480&height=360&seq=freekanliao-tl-04&orientation=landscape',
    comments: 341,
    likes: 1180,
  },
  {
    id: 5,
    time: '11:20',
    tag: '抢先',
    hot: false,
    title: '抢先首发：一组此前未见过的画面流出',
    excerpt:
      '画面清晰度一般，但信息量不小。已经有细心网友逐帧对比，找出了几个关键细节，值得慢慢看。',
    image: 'https://readdy.ai/api/search-image?query=blurred%20abstract%20photo%20frames%20layered%20on%20dark%20warm%20background%2C%20film%20strip%20texture%2C%20moody%20orange%20highlights%2C%20no%20text&width=480&height=360&seq=freekanliao-tl-05&orientation=landscape',
    comments: 208,
    likes: 902,
  },
];

export const releaseItems: ReleaseItem[] = [
  {
    id: 1,
    badge: '首发',
    title: '今日首批爆料合集：三条线索同时推进',
    desc: '免费看料今日首发内容汇总，全部按时间顺序排列，方便快速跟上进度。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20warm%20orange%20spotlight%20on%20empty%20stage%20with%20fog%2C%20abstract%20editorial%20scene%2C%20high%20contrast%2C%20no%20text&width=640&height=440&seq=freekanliao-rel-01&orientation=landscape',
    source: '免费看料首发组',
    updatedAt: '12:50 更新',
    comments: 462,
    views: '8.6万',
  },
  {
    id: 2,
    badge: '热榜',
    title: '讨论最猛的四个话题，评论区比正文还精彩',
    desc: '把最活跃的跟帖挑出来，看看大家到底在争论什么。',
    image: 'https://readdy.ai/api/search-image?query=busy%20marketplace%20crowd%20blurred%20in%20warm%20golden%20light%2C%20lively%20street%20documentary%20photography%2C%20no%20text&width=640&height=440&seq=freekanliao-rel-02&orientation=landscape',
    source: '热榜观察',
    updatedAt: '12:42 更新',
    comments: 318,
    views: '6.2万',
  },
  {
    id: 3,
    badge: '实时',
    title: '最新一小时内发生的事，逐条拆给你看',
    desc: '每条都标注了出现时间和来源，不确定的部分也如实保留。',
    image: 'https://readdy.ai/api/search-image?query=analog%20clock%20face%20close%20up%20with%20warm%20amber%20tone%20and%20soft%20shadows%2C%20minimal%20editorial%20still%20life%2C%20no%20text&width=640&height=440&seq=freekanliao-rel-03&orientation=landscape',
    source: '实时快讯',
    updatedAt: '12:36 更新',
    comments: 187,
    views: '4.9万',
  },
];

export const threadItems: ThreadItem[] = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=warm%20toned%20minimal%20avatar%20portrait%20of%20young%20person%20with%20soft%20orange%20light%2C%20clean%20background%2C%20no%20text&width=96&height=96&seq=freekanliao-av-01&orientation=squarish',
    author: '半夜刷屏的人',
    role: '活跃讨论者',
    topic: '今日实时',
    content:
      '从早上蹲到现在，免费看料更新的速度确实快。最有意思的是评论区，有人比爆料本身还早一步想到关键点。',
    time: '3分钟前',
    likes: 642,
    replies: 128,
    repliesPreview: '「同感，我今天几乎所有线索都是先在评论区看到的」',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=warm%20toned%20minimal%20avatar%20portrait%20of%20middle%20aged%20man%20with%20amber%20rim%20light%2C%20plain%20beige%20background%2C%20no%20text&width=96&height=96&seq=freekanliao-av-02&orientation=squarish',
    author: '只吃干货',
    role: '资深潜水用户',
    topic: '首发爆料',
    content:
      '不太喜欢那种标题党，这里还好，每条都标了时间和来源，不确定的也会写清楚。希望能一直保持这种克制。',
    time: '11分钟前',
    likes: 487,
    replies: 96,
    repliesPreview: '「对，能看到『待核实』三个字反而更让人放心」',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=warm%20toned%20minimal%20avatar%20portrait%20of%20young%20woman%20with%20soft%20golden%20light%2C%20clean%20cream%20background%2C%20no%20text&width=96&height=96&seq=freekanliao-av-03&orientation=squarish',
    author: '蹲后续的小李',
    role: '话题发起人',
    topic: '讨论区',
    content:
      '我发起了一个整理帖，把今天所有反转都列了一遍。欢迎大家补充，我会把新出现的版本也加进去。',
    time: '26分钟前',
    likes: 356,
    replies: 214,
    repliesPreview: '「已收藏，这种整理帖比刷十条快讯都管用」',
  },
];

export const photoItems: PhotoItem[] = [
  {
    id: 1,
    title: '今日现场画面：一组被反复转发的瞬间',
    image: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20street%20scene%20with%20amber%20sunset%20light%20and%20silhouettes%2C%20editorial%20documentary%2C%20soft%20grain%2C%20no%20text&width=560&height=720&seq=freekanliao-ph-01&orientation=portrait',
    tag: '现场',
    likes: 1284,
    tall: true,
  },
  {
    id: 2,
    title: '网友补充的细节图，信息量比想象中多',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20weathered%20paper%20notes%20and%20marker%20lines%20under%20warm%20desk%20lamp%2C%20top%20down%20editorial%2C%20no%20text&width=560&height=400&seq=freekanliao-ph-02&orientation=landscape',
    tag: '细节',
    likes: 842,
    tall: false,
  },
  {
    id: 3,
    title: '首发截图整理，时间顺序一目了然',
    image: 'https://readdy.ai/api/search-image?query=wall%20of%20pinned%20photos%20and%20strings%20in%20warm%20orange%20light%2C%20investigation%20board%20abstract%2C%20no%20text&width=560&height=400&seq=freekanliao-ph-03&orientation=landscape',
    tag: '整理',
    likes: 653,
    tall: false,
  },
  {
    id: 4,
    title: '评论区的神回复，已经做成图在传了',
    image: 'https://readdy.ai/api/search-image?query=neon%20warm%20amber%20signage%20glow%20on%20dark%20alley%20wall%2C%20moody%20night%20editorial%20photography%2C%20no%20text&width=560&height=720&seq=freekanliao-ph-04&orientation=portrait',
    tag: '热评',
    likes: 977,
    tall: true,
  },
];

export const rankItems: RankItem[] = [
  { id: 1, title: '今日实时最新线索整理', heat: '86.4万', trend: '+12%', up: true },
  { id: 2, title: '刚刚抢先首发的画面细节', heat: '72.1万', trend: '+9%', up: true },
  { id: 3, title: '讨论区正在反转的话题', heat: '64.8万', trend: '+21%', up: true },
  { id: 4, title: '免费看料首发内容合集', heat: '51.3万', trend: '+4%', up: true },
  { id: 5, title: '实时跟新中的冷门线索', heat: '43.7万', trend: '-2%', up: false },
  { id: 6, title: '昨晚到今早的重点回看', heat: '38.2万', trend: '+6%', up: true },
];

export const topicTags: { id: number; label: string; count: string }[] = [
  { id: 1, label: '免费看料今日', count: '2.4万条讨论' },
  { id: 2, label: '实时更新', count: '1.8万条讨论' },
  { id: 3, label: '首发爆料', count: '1.3万条讨论' },
  { id: 4, label: '刚刚发生', count: '9862条讨论' },
  { id: 5, label: '热评精选', count: '7540条讨论' },
  { id: 6, label: '最新整理', count: '6310条讨论' },
  { id: 7, label: '蹲后续', count: '5288条讨论' },
  { id: 8, label: '现场画面', count: '4120条讨论' },
];

export const heroStats: { id: number; label: string; value: string }[] = [
  { id: 1, label: '今日实时更新', value: '1,286' },
  { id: 2, label: '在线蹲料人数', value: '9.4万' },
  { id: 3, label: '正在进行讨论', value: '342' },
];